import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotifyService {
    private subject = new Subject<any>();

    sendMessage(msg: string) {
        this.subject.next({ text: msg });
    }

    clearMessages() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    changeLang() {
        this.subject.next({ text: 'changeLang' });
    }

    sendNewComment(msg: string, requestId: string) {
        this.subject.next({ text: msg, value: requestId });
    }
}

